<template>
  <div>
    <v-container
      class="mt-md-16 px-6 px-sm-16 px-md-4"
      style="max-width: 1000px"
    >
      <ValidationObserver ref="observer" v-on:keyup.enter="signIn">
        <v-row justify="center">
          <v-col cols="12" sm="8" md="5" lg="5" align="center">
            <img
              :src="
                $vuetify.theme.dark
                  ? require('@/app/core-module/assets/images/LOGO_DARK_MODE.png')
                  : require('@/app/core-module/assets/images/LOGO.png')
              "
              alt="Logo"
              class="mb-10"
              height="auto"
              width="180"
            />

            <v-card elevation="0" class="border-lg">
              <div class="pa-6">
                <div
                  class="
                    text-subtitle-2
                    textLight--text
                    mt-6
                    mb-2
                    text-start
                    font-weight-thin
                  "
                >
                  {{ $t("user.signIn.welcome") }}
                </div>

                <div
                  class="
                    text-h5
                    textLight--text
                    mt-3
                    mb-7
                    text-start
                    font-weight-medium
                  "
                >
                  {{ $t("user.signUp.createAccount") }}
                </div>

                <validation-provider v-slot="{ errors }" rules="required">
                  <div
                    class="
                      text-start
                      textLight--text
                      text-subtitle-2
                      font-weight-thin
                      mb-1
                    "
                  >
                    {{ $t("user.signIn.yourEmail") }}
                  </div>

                  <v-text-field
                    hide-details
                    disabled
                    :error="emailErr"
                    v-model="user.emailOrCivilIdOrPassport"
                    @click="emailErr = pwdErr = false"
                    :error-messages="errors"
                    outlined
                    :append-icon="
                      emailErr ? 'mdi-alert-circle-outline' : null
                    "
                    dense
                    class="rounded-md text-body-2"
                  >
                  </v-text-field>

                  <div
                    v-if="emailErr"
                    class="error--text text-start text-caption font-weight-thin"
                  >
                    {{ $t("user.signIn.emailErrorMsg") }}
                  </div>
                </validation-provider>

                <validation-provider v-slot="{ errors }" rules="required">
                  <div
                    class="
                      text-start
                      textLight--text
                      text-subtitle-2
                      font-weight-thin
                      mt-3
                      mb-1
                    "
                  >
                    {{ $t("user.enterNewPassword") }}
                  </div>

                  <v-text-field
                    hide-details
                    :error="pwdErr"
                    v-model="user.password"
                    @click="emailErr = pwdErr = null"
                    :error-messages="errors"
                    outlined
                    dense
                    class="rounded-md text-body-2"
                    :append-icon="
                     pwdErr ? 'mdi-alert-circle-outline' : null
                    "
                  >
                  </v-text-field>

                  <div
                    v-if="pwdErr"
                    class="error--text text-start text-caption font-weight-thin"
                  >
                    {{ $t("user.signIn.passwordErrorMsg") }}
                  </div>
                </validation-provider>
                <div
                  v-if="error"
                  class="
                    error--text
                    text-center text-caption
                    font-weight-medium
                    mt-4
                  "
                >
                  {{ error }}
                </div>

                <v-btn
                  @click="signUp"
                  :loading="loading"
                  depressed
                  large
                  dark
                  class="text-subtitle-1 rounded-md mb-2 mt-5"
                  color="textLight"
                  style="width: 100%"
                >
                  {{ $t("user.signUp.signUp").toUpperCase() }}
                </v-btn>

                <div class="d-none primary--text text-caption font-weight-thin">
                  {{ $t("user.signUp.recieveEmail") }}
                </div>
              </div>
            </v-card>

            <div class="mb-10 mt-5 text-caption font-weight-thin">
              {{ $t("user.signIn.alreadyHaveAccount") }}

              <span>
                <router-link
                  style="text-decoration: none"
                  :to="{ name: 'SignIn' }"
                >
                  {{ $t("user.signIn.login") }}
                </router-link>
              </span>

              {{ $t("user.here") }}
            </div>
          </v-col>
        </v-row>
      </ValidationObserver>
    </v-container>
  </div>
</template>

<script>
import "../../core-module/util/validationRules";
import { signUp } from "../methods/signUp";

export default {
  data() {
    return {
      loading: false,
      user: {},
      passwordValue: String,
      confirmPasswordValue: String,
      emailErr: false,
      pwdErr: false,
      token: null,
      error: null
    };
  },
  created() {
    this.token = this.$route.params.token ? this.$route.params.token : null;
    this.user.emailOrCivilIdOrPassport = this.$route.params.email
      ? this.$route.params.email
      : null;
  },
  methods: {
    async signUp() {
      const isValid = await this.$refs.observer.validate();

      if (isValid) {
        this.loading = true;

        const signUpInput = {
          emailOrCivilIdOrPassport: this.user.emailOrCivilIdOrPassport,
          password: this.user.password,
        };

        signUp(signUpInput, true, this.token).then(response => {
          if (response.data) location.reload();
          else if (response.error) {
            if( response.error.includes("NOT_FOUND")) {
              this.emailErr = true
              this.error = null
            }
           else if (response.error.includes("USER_ALREADY_EXIST"))
             {
              this.emailErr = this.pwdErr =false
              this.error = this.$t("user.signUp.userAlreadyExist")
             }
            else this.error = this.$t("somethingWentWrong");
          }

          this.loading = false;
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped />
